/**
 * SAFAA HOME — Hero Premium
 * -----------------------------------------------------------------------
 * Vanilla custom element, no dependencies. Responsible for:
 *   1. Adding the "is-loaded" class once the hero image has decoded (or
 *      immediately if the browser can't tell us), which triggers the
 *      CSS-only zoom / fade-up reveal.
 *   2. Smooth-scrolling to the next section when the scroll indicator
 *      is clicked or activated via keyboard.
 * Respects prefers-reduced-motion throughout.
 * -----------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (customElements.get('hero-premium-component')) return;

  class HeroPremium extends HTMLElement {
    connectedCallback() {
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._revealWhenReady();
      this._setupScrollIndicator();
    }

    /* ---------------------------------------------------------------
       Reveal once the hero image is decoded (avoids animating over a
       still-loading / blank image), with a safety fallback timeout.
       --------------------------------------------------------------- */

    _revealWhenReady() {
      const img = this.querySelector('.hero-premium__media img');

      const reveal = () => this.classList.add('is-loaded');

      if (this._reducedMotion || !img) {
        reveal();
        return;
      }

      if (img.complete) {
        reveal();
        return;
      }

      if (img.decode) {
        img.decode().then(reveal).catch(reveal);
      } else {
        img.addEventListener('load', reveal, { once: true });
      }

      // Never let a slow/failed decode withhold the content indefinitely.
      window.setTimeout(reveal, 1800);
    }

    /* ---------------------------------------------------------------
       Scroll indicator
       --------------------------------------------------------------- */

    _setupScrollIndicator() {
      const trigger = this.querySelector('[data-hero-scroll]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const next = this.nextElementSibling;
        if (!next) return;

        next.scrollIntoView({
          behavior: this._reducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    }
  }

  customElements.define('hero-premium-component', HeroPremium);
})();
